import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import EngineeringIcon from '@mui/icons-material/Engineering';
import BuildCircleIcon from '@mui/icons-material/BuildCircle';

export const ServiceList = [
    {
        name:"Onsite Line Boring",
        descript:"We use market leading equipments for its proven reliability and it's unsuppassed accuracy in restoring critical dimensions to original equipment manufacturer's specifications. Our Work covers all critical areas such as h-frames , booms, center articulatin , streering anchors , dog bones , swing levers and front frames .",
        icon:<EngineeringIcon/>,
    },
    {
        name:"Equipments reclamation",
        descript:"We reclaim decommissioned underground trackless mining equipment and carcasses for recycling purposes per customer prescription . Our skilled personel strip the equipments into sizable partsfor safe handling and logistical management from underground mines .",
        icon:<ChangeCircleIcon/>,
    },
    {
        name:"Equipments rebuilds",
        descript:"We rebuild various type of equipment to original equipment manufacturer (OEM) specifications and also repair various machine components such as hydraulic cylinders , gearboxes ,  transmissions and axles .",
        icon:<BuildCircleIcon/>,
    },
]